import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, throwError } from 'rxjs';
import { AuthStore } from '../../features/auth/store/auth.store';
import { ConfigStore } from '../store/config.store';
import { ChatbotStore } from '../../features/chat/store/chatbot.store';
import { SessionStore } from '../store/session.store';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const authStore = inject(AuthStore);
    const configStore = inject(ConfigStore);
    const chatbotStore = inject(ChatbotStore);
    const sessionStore = inject(SessionStore);

    return next(req).pipe(
        catchError((error: unknown) => {
            console.error('HTTP Error:', error);

            if (error instanceof HttpErrorResponse) {
                if (error.status === 401 && !req.url.includes('/refresh')) {
                    console.warn('Unauthorized request detected. Redirecting to /login.');
                    authStore.reset();
                    configStore.reset();
                    chatbotStore.reset();
                    sessionStore.reset();
                    router.navigate(['/login']);
                    return EMPTY;
                }
            }

            return throwError(() => error);
        }),
    );
};
